import WebServiceRequest from "@/libs/Api/WebServiceRequest";

// پشتیبانی تلفنی ساعتی؛ همه‌ی زمان‌ها به دقیقه
// SupportLessonStatus: 1 request · 2 payed · 3 assigned · 4 expired · 5 endTime · 6 canceled
export const SUPPORT_STATUS = {
  request: 1,
  payed: 2,
  assigned: 3,
  expired: 4,
  endTime: 5,
  canceled: 6,
};

// GET؛ count, pageNumber, teacherId, status
class GetSupportAdminList extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("SupportLesson/GetAdminList");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

// بدنه: { supportLessonId, teacherId }
class AssignSupportTeacher extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("SupportLesson/AssignTeacher");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

// بدنه: { supportLessonId, usedTime } (دقیقه)
class MarkSupportTimeUsed extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("SupportLesson/MarkTimeUsed");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

// GET؛ گزارش کل: زمان‌ها، مبلغ دریافتی، حقوق پشتیبان و سود، به تفکیک پشتیبان و زبان‌آموز
class GetSupportReport extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("SupportLesson/GetReport");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

// GET؛ { studentPricePerHour, teacherPricePerHour }
class GetSupportPrices extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("SupportLesson/GetPrices");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

// GET؛ studentId — همه‌ی نظرهای اساتید برای یک زبان‌آموز
class GetSupportCommentsByStudent extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("SupportLesson/GetCommentsByStudentId");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

export {
  GetSupportAdminList,
  AssignSupportTeacher,
  MarkSupportTimeUsed,
  GetSupportReport,
  GetSupportPrices,
  GetSupportCommentsByStudent,
};
